// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalDataSourceSubset
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { GraphicalDataSourceEdge } from "abweb/dto/gds/GraphicalDataSourceEdge";
import { GraphicalDataSourceNode } from "abweb/dto/gds/GraphicalDataSourceNode";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalDataSourceSubsetBase {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalDataSourceSubsetBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalDataSourceSubset";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalDataSourceSubset(json.edges != null ? TSOGUtils.decodeObjectArray(json.edges, GraphicalDataSourceEdge, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "edges")) : null, json.nodes != null ? TSOGUtils.decodeObjectArray(json.nodes, GraphicalDataSourceNode, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "nodes")) : null);
  }
  initGraphicalDataSourceSubset(edges, nodes) {
    this._edges = edges;
    this._nodes = nodes;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["edges"] = TSOGUtils.toTSOGArray(this._edges, serializeContext);
    retVal["nodes"] = TSOGUtils.toTSOGArray(this._nodes, serializeContext);
    return retVal;
  }
  get edges() {
    return this._edges;
  }
  set edges(value) {
    this._edges = value;
  }
  get nodes() {
    return this._nodes;
  }
  set nodes(value) {
    this._nodes = value;
  }
}
//# sourceMappingURL=GraphicalDataSourceSubsetBase.js.map
